<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="center-para"><a id="page_i"></a>Praise for Caitlin Kittredge’s<br/>Nocturne City series</p>
<p class="para"> </p>
<p class="center-para1"><em>Pure Blood</em></p>
<p class="para"> </p>
<p class="para">“<em>Pure Blood</em> pounds along hard on the heels of <em>Night Life</em>, and is every bit as much fun as the first in the series. With a gutsy, likable protagonist and a well-made fantasy world, <em>Pure Blood</em> is real enough to make you think twice about locking your doors at night. A swiftly paced plot, a growing cast of solid supporting characters, and a lead character you can actually care about—Kittredge is a winner.”</p>
<p class="right-para">—Jim Butcher</p>
<p class="para"> </p>
<p class="para">“With enough supernatural death and romance to keep readers glued to the pages…Jump in with both feet and hang on tight because <em>Pure Blood</em> is an emotion-filled ride.”</p>
<p class="right-para"><em>—Darque Reviews</em></p>
<p class="para"> </p>
<p class="para">“The pacing is rapid and the peril imminent…This is a series and an author that are definitely going places!”</p>
<p class="right-para"><em>—Romantic Times BOOKreviews</em></p>
<p class="para"> </p>
<p class="para">“The unexpected plot twists and high-octane action of <em>Pure Blood</em> kept me turning the pages until the wee hours of the morning.”</p>
<p class="right-para"><em>—Romance Junkies</em></p>
<p class="para"> </p>
<p class="center-para1"><em>Night Life</em></p>
<p class="para"> </p>
<p class="para">“Dark and cutting-edge.”</p>
<p class="right-para"><em>—Romantic Times BOOKreviews</em></p>
<p class="para"> </p>
<p class="para"><a id="page_iii"></a>“I loved the mystery and the smart, gutsy heroine.”</p>
<p class="right-para">—Karen Chance, <em>New York Times</em><br/>bestselling author of <em>Claimed by Shadow</em></p>
<p class="para"> </p>
<p class="para">“Don’t go to bed with this book—it will keep you up all night. It’s that good.”</p>
<p class="right-para">—Lilith Saintcrow, national bestselling<br/>author of <em>Working for the Devil</em></p>
<p class="para"> </p>
<p class="para">“Luna is tough, smart, and fierce, hiding a conflicted and insecure nature behind her drive for justice and independence, without falling into cliché. It’s also just a lot of fun to read.”</p>
<p class="right-para">—Kat Richardson, national<br/>bestselling author of <em>Greywalker</em></p>
<p class="para"> </p>
<p class="para">“Fast-paced, sexy, and witty with many more interesting characters than I have time to mention. I’m looking forward to reading more stories in the exciting Nocturne City series.”</p>
<p class="right-para"><em>—Fresh Fiction</em></p>
<p class="para"> </p>
<p class="para">“Wow, I am still thinking about this book. The last time I reacted to a book this way, it was the first Mercy Thompson book by Patricia Briggs. If you are looking for a book that seamlessly blends a police procedural with a paranormal, go out and get this book.”</p>
<p class="right-para"><em>—Night Owl Reviews</em></p>
<p class="para"> </p>
<p class="para">“A tense, gritty urban fantasy that grips the audience from the onset.”</p>
<p class="right-para"><em>—Mystery Gazette</em></p>
<p class="para"> </p>
<p class="para">“<em>Night Life</em> dove right into the action, and carried me along for the ride…If the following books are written with the same care and interest as <em>Night Life</em>, they will be a welcome addition to this fantasy genre.”</p>
<p class="right-para"><em>—Armchair Interviews</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?122553fe